/// User will get here after entering a credit card details and this page will poll for status of the order from the server

import React from 'react';
import Parent from '../../../common/parent';
import { withTranslation } from 'react-i18next';
import logo from '../../../images/logo.svg';
import {BllinkLogger} from "../../../common/utils/bllink_loggers";
import './failedPaymentsPage.css';
import {CreditCardForm} from "../../credit_card/CreditCardForm";
import { constants } from "../../../common/constants/constants";


export class FailedPaymentsPage extends Parent {

    constructor(props) {
        super(props);
        document.title = props.t('titles.failed_payments_page');
        let failedToken = this.props.match.params.failedToken;

        this.state = {
            failedToken: failedToken
        }
    }

    async componentDidMount() {
        const isAdmin = await this.isAdmin();
        // get token data
        this.startLoader();
        let failedTokenData = await this.client.get(`/tenants/updateCardDetails/${this.state.failedToken}`);
        BllinkLogger.info(`failedTokenData is `, failedTokenData)
        let buildingData = {};
        if (failedTokenData.apartment_details) {
            buildingData = await this.fetchBuildingData(failedTokenData.apartment_details.buildingID);
        }
        this.setState({
            failedTokenData: failedTokenData,
            buildingData: buildingData,
            loaded: true,
            isAdmin
        })

        this.endLoader();

    }

    getRelevantDetails(){

        BllinkLogger.info(`this.state.failedTokenData`, this.state.failedTokenData)
        let tenantDetails = this.state.failedTokenData.tenant_details;
        let data = this.state.failedTokenData.payment_details;
        let installmentsDetails = this.state.failedTokenData?.installments_details;
        let paymentFor = this.setPaymentFor(installmentsDetails);

        let last_4_digits = data.last_4_digits;
        let fourDigitDesktop, fourDigitMobile;
        let title = this.buildingTitle(this.state.buildingData.address, this.state.failedTokenData.apartment_details.apartmentNumber);
        fourDigitDesktop  = <p className="d-none d-md-block">{last_4_digits} **** **** ****</p>
        fourDigitMobile  = <p className="d-sm-block d-md-none">{last_4_digits} **** **** </p>


        return {
            fourDigitDesktop: fourDigitDesktop,
            fourDigitMobile: fourDigitMobile,
            fullName: tenantDetails.name,
            paymentFor,
            title: title
        }
    }

    setPaymentFor(installmentsDetails){
        let paymentFor = '';
        if (this.state.isAdmin){
            if (installmentsDetails){
                const { onGoingInstallments, oneTimePaymentsInstallments, pastPaymentsInstallments } = installmentsDetails;
                if (oneTimePaymentsInstallments){
                    paymentFor += oneTimePaymentsInstallments.map(oneTime => {return oneTime.title}).join(', ');
                }

                if (onGoingInstallments){
                    const selectedMonths = onGoingInstallments.map(onGoing => {return onGoing.selectedMonths}).flat(1);
                    paymentFor += this.calcMonthsTextForSelectBox(selectedMonths);
                }

                if (pastPaymentsInstallments){
                    const selectedMonths = pastPaymentsInstallments.map(onGoing => {return onGoing.selectedMonths}).flat(1);
                    paymentFor += this.calcMonthsTextForSelectBox(selectedMonths);
                }
            }
        }

        return paymentFor
    }


    renderCurrentPaymentDetailsForFailed(){
        /*
            last 4 digit
            tenant name
         */
        const {t} = this.props;

        if (!this.state.failedTokenData.tenant_details){
            return
        }

        let result = this.getRelevantDetails();

        return (
            <div className="container">
                <div className="row">
                    <div className="col-md-12 txt_Head">
                        <h3 className="text-center">
                            {t('payments.update_credit_card')}
                            <span>{t('payments.' + result.title.translationKey, result.title)}</span></h3>
                    </div>

                    <div className="mid-sec-Div d-flex">
                        <div className="col-md-6 right-para">
                            <p>{t('payments.4_last_digits')}</p>
                            <p>{t('payments.full_name')}</p>
                            {result.paymentFor && (<p>{t('payments.payment_for')}</p>)}
                        </div>
                        <div className="col-md-6 left-para">
                            {result.fourDigitDesktop}{result.fourDigitMobile}
                            <p>{result.fullName}</p>
                            {result.paymentFor && (<p>{result.paymentFor}</p>)}
                        </div>
                    </div>
                </div>
            </div>
        )
    }


    renderUpdateCardForm(){
        /*
            card number
            expiry
            cvv

            pay button
            tourist comment disclaimer
         */

        BllinkLogger.info(`renderUpdateCardForm`, this.state.failedTokenData);
        let data = this.state.failedTokenData;
        let paymentTerminal = data.paymentTerminal;

        return (
            <CreditCardForm
                parentProps={this.props}
                hasCommission={data.hasTenantCommission}
                amountForFirstPayment={data.firstPaymentTotal}
                paymentsToken={data.paymentsToken}
                currency={data.currency}
                isOnePaymentCart={true}
                renderPayButton={data.cartID}
                paymentTerminal={paymentTerminal}
                cartID={data.cartID}
                isFailedPaymentForm={true}
            />
        )
    }

    renderTitleWithLogo(){
        const {t} = this.props;
        return (
            <div className="container">
                <div className="row">
                    <div className="col-md-12 last-border-line">
                        <div className="main-sec-top-c failed-payment-title">
                            <h2>{t('payments.failed_payment_title')}</h2>
                            <img alt="blink" className="img-responsive" src={logo}/>
                        </div>
                    </div>
                </div>
            </div>
        )
    }

    renderFailedStatusFromServer(text){
        return (
            <div className="container">
                <div className="chk_card">
                    <form className="card_from_new">
                        <div className="inner_from_Div text-center">
                            <div className="row form-group">
                                <h3>{text}</h3>
                            </div>
                        </div>
                    </form>
                </div>
            </div>
        )
    }


    render() {

        const {t} = this.props;
        if (!this.state.loaded){
            return ''
        }

        let data = this.state.failedTokenData;
        let valid = data.valid;
        let creditCardSection = '';
        if (!valid){
            if (data.shouldUpdateAtNormalFlow){
                let buildingLink = `${constants.frontendUrl}/buildings/${data.buildingID}`;
                let text = t('payments.payment_plan_not_active_pay_at_building_page', {buildingLink: (<a href={buildingLink}>כאן</a>)});
                creditCardSection = this.renderFailedStatusFromServer(text);
            }else{
                let text = t('payments.already_updated_this_failed_payment');
                creditCardSection = this.renderFailedStatusFromServer(text);
            }
        }else{
            creditCardSection = this.renderUpdateCardForm();
        }

        return (
            <div className="container">
                {this.renderTitleWithLogo()}
                {this.renderCurrentPaymentDetailsForFailed()}
                {creditCardSection}
            </div>
        )
    }
}

export default withTranslation()(FailedPaymentsPage);
